//React Library
import React, { useState, useEffect } from "react";

//Material UI Styles
import { lighten, makeStyles, withStyles } from "@material-ui/core/styles";
//Material UI Components
import Grid from "@material-ui/core/Grid";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";
import List from "@material-ui/core/List";
import Tooltip from "@material-ui/core/Tooltip";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Popover from "@material-ui/core/Popover";
import Select from "@material-ui/core/Select";
import Menu from "@material-ui/core/Menu";
import { CircularProgress } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import MuiPhoneNumber from "material-ui-phone-number";
import Visibility from "@material-ui/icons/Visibility";
import FormControl from "@material-ui/core/FormControl";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import CustomToolTip from "../../Global/PasswordGuileline";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { Switch, Route } from "react-router-dom";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Table from "@material-ui/core/Table";
import Container from "@material-ui/core/Container";
import moment from "moment";
import Typography from "@material-ui/core/Typography";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import DeleteIcon from "@material-ui/icons/Delete";
import TableRow from "@material-ui/core/TableRow";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import StartIcon from "@material-ui/icons/Check";
import EditIcon from "@material-ui/icons/Edit";

//Child Components
import Template1 from "./template";
import Template2 from "../templateTools/templateResponse";
import Template3 from "../publicTemplates/publicTemplates";
import Template4 from "../templateArchives/templateArchives";
import Sidebar from "./PreviewSidebar";
import MoreOptionDailog from "../templateTools/MoreOptionDailog";
import MiddleHeader from "../middleHeader/middleHeader";

//Global Elements
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";
import refresh_token from "../../Global/refresh_token";
import Spinner from "../../Global/Spinner2";
import DarkButton from "../../Global/DarkButton";
import NoRecords from "../../Global/NoRecords";

//Custom Css + Images
import "./template.css";
import swal from "@sweetalert/with-react";
import Delete from "../../Assets/delete.png";
import dots from "../../Assets/dots.png";
import dotsH from "../../Assets/dotsH.png";
import pencil from "../../Assets/pencil.png";
import pencilG from "../../Assets/pencilG.png";
import start from "../../Assets/start.png";
import startG from "../../Assets/startG.png";
import search from "../../Assets/search.png";
import file from "../../Assets/file.png";
import share from "../../Assets/share.png";
import timetable from "../../Assets/timetable.png";
import add from "../../Assets/add.png";
import filter from "../../Assets/Filter_Icon.png";

//React Router
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";

//Redux
import { addTeam } from "../../Redux/Actions/teamAction";
import { useSelector, useDispatch } from "react-redux";

//Others
import uuid from "react-uuid";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  container: {
    maxHeight: "53vh",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "12px",
    fontSize: "12px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
}));

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const AntTabs = withStyles({
  root: {
    backgroundColor: "#ffffff",
    color: "#222",
  },
  indicator: {
    backgroundColor: "#1a73e8",
    // display:'none'
  },
})(Tabs);

function TemplateNav() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [templates, setTemplates] = useState([]);
  const [accessWith, setAccessWith] = useState([]);
  const [sharedWith, setSharedWith] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [userFilter, setUserFilter] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageNo, setPageNo] = useState(0);
  const [filterApplied, setFilterApplied] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    Access: false,
    Users: false,
  });
  const [currentEditRow, setCurrentEditRow] = React.useState({});
  const [datesFilters, setDateFilters] = React.useState({
    today: false,
    yesterday: false,
    last7: false,
    last15: false,
    lastMonth: false,
    startFlag: false,
    endFlag: false,
    startDate: moment().format("YYYY-MM-DD"),
    endDate: moment().format("YYYY-MM-DD"),
  });
  const [industries, setIndustries] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedAccess, setSelectedAccess] = useState([]);
  const [token, setToken] = useState("");
  const [currentIndustry, setCurrentIndustry] = useState("");
  const [packageDetails, setPackageDetails] = useState({});
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("calories");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [dense, setDense] = useState(false);
  const [tempLoader, setTempLoader] = useState(false);
  const [loader, setLoader] = useState(true);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [rows, setRows] = useState([]);
  const [currentUser, setCurrentUser] = useState({});
  const [team, setTeam] = useState([]);
  const [permissions_obj, setPermissionObj] = useState({});
  const [teamArr, setTeamArr] = useState([]);
  const [currentCompany, setCurrentCompany] = useState({});
  let history = useHistory();
  const [value, setValue] = React.useState(0);

  const [anchorEl, setAnchorEl] = useState(null);
  const [filterMenu1, setFilterMenu1] = useState(null);
  const [filterMenu2, setFilterMenu2] = useState(null);
  const [filterMenu3, setFilterMenu3] = useState(null);
  const [filterMenu4, setFilterMenu4] = useState(null);
  var blank_template = [
    {
      id: uuid(),
      title: "Title Page",
      type: "fixed section",
      position: 1,
      status: "New",

      checklist: {
        template: { id: uuid() },
        list: [
          {
            id: "New-" + uuid(),
            title: "Conducted on",
            dataType: "DateTime",
            position: 1,
            status: "New",
            responseLibrary: [],
            mandatory: false,
            multiselection: false,
            condition: "",
            conditionValue: "",
            conditional: "no",
            parent: null,
            isopen: "no",
            conditionalList: [],
            subQuestion: "no",
            is_subquestion:'no',
            isopenSub:"no",
            subQuestionList: []
          },
          {
            id: "New-" + uuid(),
            title: "Prepared by",
            dataType: "Text field",
            position: 2,
            status: "New",
            responseLibrary: [],
            mandatory: false,
            multiselection: false,
            condition: "",
            conditionValue: "",
            conditional: "no",
            parent: null,
            isopen: "no",
            conditionalList: [],
            subQuestion: "no",
            is_subquestion:'no',
            isopenSub:"no",
            subQuestionList: []
          },
          {
            id: "New-" + uuid(),
            title: "Location",
            dataType: "Location",
            position: 3,
            status: "New",
            responseLibrary: [],
            mandatory: false,
            multiselection: false,
            condition: "",
            conditionValue: "",
            conditional: "no",
            parent: null,
            isopen: "no",
            conditionalList: [],
            subQuestion: "no",
            is_subquestion:'no',
            isopenSub:"no",
            subQuestionList: []
          },
        ],
      },
    },
    {
      id: uuid(),
      title: "Inspection",
      type: "section",
      position: 2,
      status: "New",
      checklist: {
        template: { id: uuid() },
        list: [
          {
            id: "New-" + uuid(),
            title: "",
            dataType: "Text field",
            position: 1,
            status: "New",
            responseLibrary: [],
            mandatory: false,
            multiselection: false,
            condition: "",
            conditionValue: "",
            conditional: "no",
            parent: null,
            isopen: "no",
            conditionalList: [],
            subQuestion: "no",
            is_subquestion:'no',
            isopenSub:"no",
            subQuestionList: []
          },
        ],
      },
    },
  ];

  const handleScroll = (e) => {
    let currentRecords = rows?.length;
    const bottom =
      e.target.scrollHeight - Math.ceil(e.target.scrollTop) ===
      e.target.clientHeight;
    const top = e.target.scrollTop == 0;
    if (bottom) {
      if (currentRecords < totalRecords) {
        let _pageNo = pageNo + 1;

        if (
          datesFilters.today == true ||
          datesFilters.yesterday == true ||
          datesFilters.last7 == true ||
          datesFilters.last15 == true ||
          datesFilters.lastMonth == true ||
          datesFilters.startFlag == true ||
          datesFilters.endFlag == true
        ) {
          setFilterApplied(true);
          getMoreTemplates(currentCompany, false, _pageNo);
        } else {
          setFilterApplied(false);
          getMoreTemplates(currentCompany, true, _pageNo);
        }
      }
    }
  };

  const getPermissions = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log(response);
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[v.title] = true;
            });

            console.log("Apple", permissionsObj);

            setPermissionObj(permissionsObj);
            setLoader(false);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log(error.message);
        });
    } else {
      setLoader(false);
    }
  };

  const handleClick2 = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClick3 = (event) => {
    setFilterMenu1(event.currentTarget);
  };
  const handleClick4 = async (event) => {
    setFilterMenu2(event.currentTarget);
    setFilterMenu3(null);
    setFilterMenu4(null);
  };

  const handleClick5 = async (event) => {
    setFilterMenu2(null);
    setFilterMenu3(event.currentTarget);
    setFilterMenu4(null);
  };

  const handleClick6 = async (event) => {
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu4(event.currentTarget);
  };

  const handleClose2 = () => {
    setAnchorEl(null);
  };

  const handleClose3 = () => {
    setFilterMenu1(null);
  };

  const handleClose4 = () => {
    setFilterMenu2(null);
  };

  const handleClose5 = () => {
    setFilterMenu3(null);
  };

  const handleClose6 = () => {
    setFilterMenu4(null);
  };

  const open = Boolean(filterMenu1);
  const open2 = Boolean(filterMenu2);
  const open3 = Boolean(filterMenu3);
  const open4 = Boolean(filterMenu4);

  const selectUsers = (checked, item) => {
    const nextselectedUsers = checked
      ? [...selectedUsers, item.id]
      : selectedUsers.filter((t) => t !== item.id);
    setSelectedUsers(nextselectedUsers);
  };

  const selectAccess = (checked, item) => {
    const nextselectedAccess = checked
      ? [...selectedAccess, item]
      : selectedAccess.filter((t) => t !== item);
    setSelectedAccess(nextselectedAccess);
  };

  const handleDone = () => {
    document.getElementById("TemplateScroll").scrollTo(0, 0);
    console.log(datesFilters);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      getTemplates(currentCompany);
    } else {
      setFilterApplied(false);
      getTemplates(currentCompany, true);
    }
    setFilterMenu1(null);
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu4(null);

    if (selectedAccess.length > 0) {
      setAppliedFilters({ ...appliedFilters, Access: true });
    } else if (selectedUsers.length > 0) {
      setAppliedFilters({ ...appliedFilters, Users: true });
    } else if (selectedAccess.length == 0) {
      setAppliedFilters({ ...appliedFilters, Access: false });
    } else if (selectedUsers.length == 0) {
      setAppliedFilters({ ...appliedFilters, Users: false });
    }
  };

  const handleDone2 = () => {
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      getTemplates(currentCompany);
    } else {
      setFilterApplied(false);
      getTemplates(currentCompany, true);
    }
    document.getElementById("TemplateScroll").scrollTo(0, 0);
    setFilterMenu1(null);
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
  };

  const handleToday = () => {
    let _datesFilters = {
      ...datesFilters,
      today: !datesFilters.today,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };

    setDateFilters(_datesFilters);
  };

  const handleYesterday = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: !datesFilters.yesterday,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
      endDate: moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handle7Days = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: !datesFilters.last7,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(7, "days")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };

    setDateFilters(_datesFilters);
  };

  const handle15Days = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: !datesFilters.last15,
      lastMonth: false,
      startDate: moment()
        .subtract(15, "days")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setDateFilters(_datesFilters);
  };

  const handle1Month = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: !datesFilters.lastMonth,
      startFlag: false,
      endFlag: false,
      startDate: moment()
        .subtract(1, "month")
        .format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };

    setDateFilters(_datesFilters);
  };

  const handleStartDate = (e) => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: true,
      startDate: e.target.value,
    };
    console.log(_datesFilters);

    setDateFilters(_datesFilters);
  };

  const handleEndDate = (e) => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      endFlag: true,
      endDate: e.target.value,
    };
    setDateFilters(_datesFilters);
  };

  const onSelectUser = () => {
    setFilterMenu1(null);
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    getTemplates(currentCompany);
  };

  const onSelectAccess = () => {
    setFilterMenu1(null);
    setFilterMenu2(null);
    setFilterMenu3(null);
    setFilterMenu4(null);
    getTemplates(currentCompany);
  };

  const headCells = [
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Template Title",
      borderLeft: false,
      borderRight: false,
    },
    {
      id: "status",
      numeric: true,
      disablePadding: false,
      label: "Status",
      borderLeft: true,
      borderRight: true,
    },
    {
      id: "scheduled",
      numeric: true,
      disablePadding: false,
      label: "Scheduled",
      borderLeft: false,
      borderRight: false,
    },
    {
      id: "shared",
      numeric: true,
      disablePadding: false,
      label: "Shared",
      borderLeft: true,
      borderRight: true,
    },
    // { id: "edit", numeric: true, disablePadding: false, label: " " },
    // { id: "Preview", numeric: true, disablePadding: false, label: " " },
    {
      id: "startInspection",
      numeric: true,
      disablePadding: false,
      label: "Start Schedule",
      borderLeft: false,
      borderRight: false,
    },
    {
      id: "action",
      numeric: true,
      disablePadding: false,
      label: "Actions",
      borderLeft: true,
      borderRight: false,
    },
  ];

  const addSection = (
    title,
    template_id,
    user,
    checklist,
    token,
    type,
    position
  ) => {
    var obj = {
      title: title,
      template_id: template_id,
      status: "active",
      created_by: user,
      type: type,
      position: position,
    };
    var token = token;
    console.log("create section Api called");
    fetch(GlobalApi + "/Section/create_section", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("response from create Section", res);
        if (res.status === "Success") {
          //===================== Add checklist===============//
          await checklist.map((item) => {
            //alert(JSON.stringify(item.responseLibrary.responses))
            // if (item.status == "New")
            addChecklistItem(
              item.title,
              res.data.id,
              user,
              item.position,
              item.dataType,
              token,
              item.responseLibrary,
              item.mandatory,
              item.multiselection,
              item.condition,
              item.conditionValue,
              item.conditional,
              item.parent,
              item.conditionalList,
              item?.type,
              item?.is_subquestion,
              item.subQuestionList
            );
          });

          //==================================================//
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            addSection(title, template_id, user, checklist, token);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const addResponseLibrary = (
    title,
    check_id,
    response_id,
    user,
    token,
    status
  ) => {
    var obj = {
      title: title,
      check_id: check_id,
      response_id: response_id,
      status: "active",
      created_by: user,
      delete: status,
    };
    var token = token;
    console.log("create response library api called");
    fetch(GlobalApi + "/ResponseSet/create_response_set", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("response of create response set", res);
        if (res.status === "Success") {
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            addResponseLibrary(title, check_id, response_id, user, token);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const addChecklistItem = (
    title,
    section_id,
    user,
    position,
    dataType,
    token,
    responseLibrary,
    mandatory,
    multiselection,
    condition,
    conditionValue,
    conditional,
    parent,
    conditionalList,
    type,
    is_subquestion,
    subQuestionList,
  ) => {
    var obj = {
      title: title,
      section_id: section_id,
      status: "active",
      created_by: user,
      position: position,
      data_type: dataType,
      is_mandatory: mandatory,
      is_multiple_allowed: multiselection,
      condition: condition,
      condition_value: conditionValue,
      is_conditional: conditional,
      parent_id: parent,
      type:type,
      is_subquestion : is_subquestion,
    };
    var token = token;
    console.log("create checklist api called");
    fetch(GlobalApi + "/CheckList/create_check_list", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("response of create checklist", res);
        if (res.status === "Success") {
          //===================== Add checklist===============//
          if (dataType == "Custom" || dataType == "Global") {
            await responseLibrary.responses.map((r, index) => {
              addResponseLibrary(
                r.title,
                res.data.id,
                r.id,
                user,
                token,
                index == 0 ? true : false
              );
            });
          }
          //==================================================//
          //===================== Add Conditional checklist===============//
          if (conditional == "yes") {
            conditionalList.map((item) => {
              // if (item.status == "New")
              addChecklistItem(
                item.title,
                section_id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                res.data.id,
                item?.type,
                item?.is_subquestion,
                item?.subQuestionList
              );

              if (item.status == "changed" || item.status == "deleted") {
              }
              // updateChecklistItem(
              //   item.title,
              //   section_id,
              //   user,
              //   item.position,
              //   item.dataType,
              //   token,
              //   item.responseLibrary,
              //   item.status,
              //   item.id,
              //   item.mandatory,
              //   item.multiselection,
              //   item.condition,
              //   item.conditionValue,
              //   item.conditional,
              //   item.parent
              // );
            });
          }

          if(is_subquestion == "yes"){
            subQuestionList.map((item) => {
              // if (item.status == "New")
              addChecklistItem(
                item.title,
                section_id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                res.data.id,
                item?.type,
                item?.is_subquestion,
                item?.subQuestionList
              );

              if (item.status == "changed" || item.status == "deleted") {
              }
              
            });
          }

          //==================================================//
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            addChecklistItem(
              title,
              section_id,
              user,
              position,
              dataType,
              token,
              responseLibrary,
              mandatory,
              multiselection,
              condition,
              conditionValue,
              conditional,
              parent,
              conditionalList,
              type,
              is_subquestion,
              subQuestionList
            );
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };

  const createCustomTemplate = async (template) => {
    swal({
      title: t("Are you sure?"),
      text: t("A new default template will be created?"),
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        var retrievedData = localStorage.getItem("UserData");
        var data = JSON.parse(retrievedData);
        if (data.token == null) {
          return <Redirect to={"/signin"} />;
        }

        var user = data.user_id;
        var obj = {
          title: "Untitled Template", //organization_id:'408576c3-0471-467e-9f55-f4c44bb54c6e',
          company_id: currentCompany.id,
          description: "Add Description",
          status: "draft",
          created_by: user,
        };
        console.log("create template APi called");

        var token = data.token;
        fetch(GlobalApi + "/Template/create_template", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify(obj),
        })
          .then((response) => response.json())
          .then(async (res) => {
            console.log("response of create template", res);
            if (res.msg === "success") {
              console.log("create template share APi called");
              fetch(GlobalApi + "/TemplateShare/create_template_share", {
                method: "post",
                headers: new Headers({
                  Authorization: "Bearer " + token,
                  "Content-Type": "application/json",
                }),
                body: JSON.stringify({
                  user_id: user,
                  company_id: res.data.organization_id,
                  template_id: res.data.id,
                  isOwner: true,
                  isEditor: true,
                }),
              });
              await blank_template.map(async (section) => {
                // if (section.status == "New")
                await addSection(
                  section.title,
                  res.data.id,
                  user,
                  section.checklist.list,
                  token,
                  section.type,
                  section.position
                );
              });
              // setTimeout(async () => {
              //   this.setState({ templateId: res.data.id });
              // }, 3000);

              console.log("template id im sending", res.data.id);

              history.push({
                pathname: "/show",
                state: { action: "edit", templateId: res.data.id },
              });
            } else if (
              res.error === "jwt expired" ||
              res.error === "invalid token" ||
              res.error === "invalid signature" ||
              res.error == "Unexpected token"
            ) {
              let status = await refresh_token();
              console.log(status);
              if (status) {
                console.log("opopopop");
                this.handleBack();
              }
            }
          })
          .catch((err) => {
            console.log(err, "error");
          });
      } else {
        console.log("Canceled");
      }
    });
  };

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function EnhancedTableHead(props) {
    const {
      classes,
      onSelectAllClick,
      order,
      orderBy,
      numSelected,
      rowCount,
      onRequestSort,
    } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {/* <TableCell padding="checkbox">
                  <Checkbox />
                </TableCell> */}
          {headCells.map((headCell, index) => (
            <TableCell
              style={{
                borderTop: "1px solid #dadada",
                borderLeft: headCell.borderLeft ? "1px solid #dadada" : "none",
                borderRight: headCell.borderRight
                  ? "1px solid #dadada"
                  : "none",
                padding: "7px",
                fontWeight: "bold",
                color: Colors.globalColor8,
                textTransform: "capitalize",
                backgroundColor: "#f2f2f2",
              }}
              key={headCell.id}
              width={index == 0 && "50%"}
              align={"left"}
              padding={headCell.disablePadding ? "none" : "default"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {/* <TableSortLabel
                      active={orderBy === headCell.id}
                      direction={orderBy === headCell.id ? order : "asc"}
                      onClick={createSortHandler(headCell.id)}
                    > */}
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
              {/* </TableSortLabel> */}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(["asc", "desc"]).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;

    return "";
  };

  EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
  };

  React.useEffect(() => {
    if (window.location.pathname == "/template/archive") {
      setValue(3);
    } else if (window.location.pathname == "/template/public") {
      setValue(2);
    } else if (window.location.pathname == "/template/response") {
      setValue(1);
    } else {
      setValue(0);
    }
  }, []);

  let industryData = useSelector((state) => state.industryArrReducer.industry);

  useEffect(
    () => {
      setIndustries(industryData);
    },
    [industryData]
  );

  let userData = useSelector((state) => state.userReducer.user);

  useEffect(
    () => {
      setToken(userData.token);
      setCurrentIndustry(userData.industry_id);
      getIndustriesTemplates(userData.industry_id, userData.token);
    },
    [userData]
  );

  useEffect(() => {
    getPackageDetails();
  }, []);

  let teamArray = useSelector((state) => state.teamReducer.team);

  console.log("teamArray", teamArray);

  useEffect(
    () => {
      setTeam(teamArray.data);
      let _team = [];
      teamArray.data.forEach((item) => {
        _team.push({
          ...item,
          checked: false,
        });
        setTeamArr(_team);
      });
    },
    [teamArray]
  );

  console.log("teamArr&&&&&&&&&&&&&&&&&&&", teamArr);

  let company = useSelector((state) => state.companyReducer.company);
  React.useEffect(
    () => {
      setCurrentCompany(company);
      let localstorage = localStorage.getItem("UserData");
      var data = JSON.parse(localstorage);
      setCurrentUser(data);
      getTemplates(company, true);
      getPermissions();
    },
    [company?.id]
  );

  // const getInspection = () => {
  //   let localstorage = localStorage.getItem("UserData");
  //   var data = JSON.parse(localstorage);
  //   let token = data.token;
  //   let params = {
  //     user_id: data.user_id,
  //   };
  //   console.log(data.user_id);
  //   let query = Object.keys(params)
  //     .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
  //     .join("&");

  //   fetch(GlobalApi + "/Inspection/get_all_inspections_share?" + query, {
  //     method: "GET",
  //     headers: {
  //       Authorization: "Bearer " + token,
  //       "Content-Type": "application/json",
  //     },
  //   })
  //     .then((responseJson) => responseJson.json())
  //     .then(async (response) => {
  //       if (response.status === "Success") {
  //         if (response.data) {
  //           setRows(response.data);

  //           // setInspection(response.data);
  //           console.log(response, "{}{}{}{}");
  //         }
  //       } else if (
  //         response.error === "jwt expired" ||
  //         response.error === "invalid token" ||
  //         response.error === "invalid signature" ||
  //         response.error === "Unexpected token"
  //       ) {
  //         let status = await refresh_token();
  //         console.log(status);
  //         if (status) {
  //           console.log("opopopop");
  //           getInspection();
  //         }
  //       }
  //     })
  //     .catch((error) => console.log(error.message));
  //   console.log("op");
  // };

  const getTemplates = async (
    currentCompany,
    reset = false,
    _selectedAccess = undefined,
    _selectedUsers = undefined
  ) => {
    setTempLoader(true);
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }

    var params = {
      skip: 0,
      noOfRecords: 15,
      company_id: currentCompany.id,
      user_id: data.user_id,
      access_to: JSON.stringify(
        _selectedUsers == undefined ? selectedUsers : _selectedUsers
      ),
      shared_with: JSON.stringify(
        _selectedAccess == undefined ? selectedAccess : _selectedAccess
      ),
      from_d: reset ? undefined : datesFilters.startDate,
      to_d: reset
        ? undefined
        : moment(datesFilters.endDate)
            .add(1, "d")
            .format("YYYY-MM-DD"),
    };

    console.log("::::::::::::::::::::::::::::::::::::::", params);

    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(
      GlobalApi + "/TemplateShare/get_all_template_shares_for_user?" + query,
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then(async (res) => {
        if (res.status === "Success") {
          setTotalRecords(res.total_records);
          console.log(res.data);
          var result = res.data;
          var templateList = [];
          await result.map((data) => {
            var template = {
              id: data.id,
              name: data.title,
              description: data.description,
              scheduled: data.Schedules?.length > 0 ? "Yes" : "no",
              modified: "",
              shared: data.TemplateShares?.length > 1 ? "Yes" : "no",
              createdBy: data.created_by,
              createdAt: data.createdAt,
              status: data.status,
              report_template_id: data.report_template_id,
              TemplateShares: data.TemplateShares,
              created_by: data.created_by,
            };
            templateList.push(template);
          });

          setRows(
            templateList.sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )
          );
          setTempLoader(false);
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
          }
        }
      })
      .catch((err) => {
        setTempLoader(false);
        console.log(err, "error");
      });
  };

  const getMoreTemplates = async (
    currentCompany,
    reset = false,
    page_no = 0
  ) => {
    // setTempLoader(true)
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }

    var params = {
      skip: rows?.length,
      noOfRecords: 15,
      company_id: currentCompany.id,
      user_id: data.user_id,
      access_to: JSON.stringify(selectedUsers),
      shared_with: JSON.stringify(selectedAccess),
      from_d: reset ? undefined : datesFilters.startDate,
      to_d: reset
        ? undefined
        : moment(datesFilters.endDate)
            .add(1, "d")
            .format("YYYY-MM-DD"),
    };
    console.log("::::::::::::::::::::::::::::::::::::::::::::::", params);

    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    await fetch(
      GlobalApi + "/TemplateShare/get_all_template_shares_for_user?" + query,
      {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then(async (res) => {
        console.log(
          "YEYEYEYEYEYE________________________________________________________________________________________________________________________",
          res
        );
        if (res.status === "Success") {
          setTotalRecords(res.total_records);
          console.log(res.data);
          var result = res.data;
          var templateList = [...rows];
          await result.map((data) => {
            var template = {
              id: data.id,
              name: data.title,
              description: data.description,
              scheduled: data.Schedules?.length > 0 ? "Yes" : "no",
              modified: "",
              shared: data.TemplateShares?.length > 1 ? "Yes" : "no",
              createdBy: data.created_by,
              createdAt: data.createdAt,
              status: data.status,
              report_template_id: data.report_template_id,
              TemplateShares: data.TemplateShares,
              created_by: data.created_by,
            };
            templateList.push(template);
          });

          setRows(
            templateList.sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            )
          );
          setTempLoader(false);
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
          }
        }
      })
      .catch((err) => {
        setTempLoader(false);
        console.log(err, "error");
      });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows?.length - page * rowsPerPage);
  const ModalOpen = (row) => {
    setIsModalOpen(row);
  };

  const clearDatesFilter = () => {
    let _datesFilters = {
      ...datesFilters,
      today: false,
      yesterday: false,
      last7: false,
      last15: false,
      lastMonth: false,
      startFlag: false,
      endFlag: false,
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    };
    setFilterApplied(false);
    setDateFilters(_datesFilters);
    getTemplates(currentCompany, true);
  };

  const clearUsersFilter = () => {
    setSelectedUsers([]);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      getTemplates(currentCompany, false, selectedAccess, []);
    } else {
      getTemplates(currentCompany, true, selectedAccess, []);
    }
  };

  const clearOwnerFilter = () => {
    let _selectedAccess = [...selectedAccess];
    const nextselectedAccess = _selectedAccess.filter((t) => t !== "owner");
    if (nextselectedAccess.length == 0) {
      setAppliedFilters({ ...appliedFilters, Access: false });
    }
    setSelectedAccess(nextselectedAccess);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      getTemplates(currentCompany, false, nextselectedAccess);
    } else {
      setFilterApplied(false);
      getTemplates(currentCompany, true, nextselectedAccess);
    }
  };

  const clearSharedFilter = () => {
    let _selectedAccess = [...selectedAccess];
    const nextselectedAccess = _selectedAccess.filter((t) => t !== "shared");
    if (nextselectedAccess.length == 0) {
      setAppliedFilters({ ...appliedFilters, Access: false });
    }
    setSelectedAccess(nextselectedAccess);
    if (
      datesFilters.today == true ||
      datesFilters.yesterday == true ||
      datesFilters.last7 == true ||
      datesFilters.last15 == true ||
      datesFilters.lastMonth == true ||
      datesFilters.startFlag == true ||
      datesFilters.endFlag == true
    ) {
      setFilterApplied(true);
      getTemplates(currentCompany, false, nextselectedAccess);
    } else {
      setFilterApplied(false);
      getTemplates(currentCompany, true, nextselectedAccess);
    }
  };

  const getPackageDetails = async () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data == undefined) {
      return <Redirect to={"/signin"} />;
    }
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  };

  const changeIndustry = (e) => {
    console.log("Industry Value", e.target.value);
    setCurrentIndustry(e.target.value);
    getIndustriesTemplates(e.target.value, token);
  };

  function getIndustriesTemplates(industry_Id, Token) {
    console.log("get industries function called>>>>>>>>>>");
    let data = localStorage.getItem("UserData");
    let params = { industry_id: industry_Id };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    fetch(
      GlobalApi + "/Template/get_all_public_templates_industries?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + Token,
          "Content-Type": "application/json",
        },
      }
    )
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("response from get all pubnlic >>>>>>>>>>", response);
        if (response.status === "Success") {
          console.log("templates >>>>>>>>>>>>>>>>", response);
          setTemplates(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  }

  return (
    <>
      <MiddleHeader />
      <div
        className=""
        style={{
          padding: "20px",
          overflow: "auto",
          backgroundColor: "#eaf7fe",
        }}
      >
        <div>
          {/* ================================== Recently Created Templates  ========================= */}
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            className="scrollHidden shadow"
            style={{
              backgroundColor: "white",
              padding: "0px",
              borderRadius: "5px",
              marginTop: "0px",
              overflowY: "hidden",
              width: "100%",
              height: "100%",
            }}
          >
            <Grid
              item
              xs={12}
              md={12}
              lg={12}
              style={{
                padding: "5px 20px 0px",
                borderBottomWidth: "1px",
                borderBottomStyle: "solid",
                borderBottomColor: Colors.globalColor4,
              }}
            >
              <Grid container justify="space-between" alignItems="center">
                <Grid item xs={12} md={12} lg={8}>
                  {/* For Web */}
                  {window.innerWidth > 700 && (
                    <AntTabs
                      className="scheduleTabHeader"
                      style={{ color: Colors.buttonTextColor }}
                      value={value}
                      onChange={handleChange}
                      aria-label="simple tabs example"
                    >
                      <Tab
                        className="templateTab"
                        style={{
                          marginTop: "5px",
                          textTransform: "uppercase",
                          fontSize: 12,
                          fontWeight: "bold",
                          backgroundColor:
                            value == 0 ? Colors.globalColor9 : "transparent",
                          color: value == 0 ? "#1a73e8" : "black",
                        }}
                        label={t("My Templates")} 
                        {...a11yProps(0)}
                        component={Link}
                        to="/template"
                      />
                      <Tab
                        className="templateTab"
                        style={{
                          marginTop: "5px",
                          textTransform: "uppercase",
                          fontWeight: "bold",
                          fontSize: 12,
                          backgroundColor:
                            value == 1 ? Colors.globalColor9 : "transparent",
                          color: value == 1 ? "#1a73e8" : "black",
                        }}
                        label={t("Response")} 
                        {...a11yProps(1)}
                        component={Link}
                        to="/template/response"
                      />
                      <Tab
                        className="templateTab"
                        style={{
                          marginTop: "5px",
                          textTransform: "uppercase",
                          fontSize: 12,
                          fontWeight: "bold",
                          backgroundColor:
                            value == 2 ? Colors.globalColor9 : "transparent",
                          color: value == 2 ? "#1a73e8" : "black",
                        }}
                        label={t("Public Templates")} 
                        {...a11yProps(2)}
                        component={Link}
                        to="/template/public"
                      />
                      {(packageDetails?.package?.title == "Enterprise" || packageDetails?.package?.title == "Free")&& <Tab
                        className="templateTab"
                        style={{
                          marginTop: "5px",
                          textTransform: "uppercase",
                          fontSize: 12,
                          fontWeight: "bold",
                          backgroundColor:
                            value == 3 ? Colors.globalColor9 : "transparent",
                          color: value == 3 ? "#1a73e8" : "black",
                        }}
                        label={t("Archives")} 
                        {...a11yProps(2)}
                        component={Link}
                        to="/template/archive"
                      />}
                    </AntTabs>
                  )}
                  {/* For Tab */}
                  {window.innerWidth > 500 && window.innerWidth <= 700 && (
                    <AntTabs
                      className="scheduleTabHeader2"
                      style={{ color: Colors.buttonTextColor }}
                      value={value}
                      onChange={handleChange}
                      aria-label="simple tabs example"
                    >
                      <Tab
                        className="templateTab2"
                        style={{
                          margin: "5px 0px 0px",
                          textTransform: "uppercase",
                          fontSize: 10,
                          fontWeight: "bold",
                         
                          backgroundColor:
                            value == 0 ? Colors.globalColor9 : "transparent",
                          color: value == 0 ? Colors.globalColor8 : "black",
                        }}
                        label={t("My Templates")} 
                        {...a11yProps(0)}
                        component={Link}
                        to="/template"
                      />
                      <Tab
                        className="templateTab2"
                        style={{
                          margin: "5px 0px 0px",
                          textTransform: "uppercase",
                        
                          fontWeight: "bold",
                          fontSize: 10,
                          backgroundColor:
                            value == 1 ? Colors.globalColor9 : "transparent",
                          color: value == 1 ? Colors.globalColor8 : "black",
                        }}
                        label={t("Response")} 
                        {...a11yProps(1)}
                        component={Link}
                        to="/template/response"
                      />
                      <Tab
                        className="templateTab2"
                        style={{
                          margin: "5px 0px 0px",
                          textTransform: "uppercase",
                          fontSize: 10,
                          fontWeight: "bold",
                   
                          backgroundColor:
                            value == 2 ? Colors.globalColor9 : "transparent",
                          color: value == 2 ? Colors.globalColor8 : "black",
                        }}
                        label={t("Public Templates")} 
                        {...a11yProps(2)}
                        component={Link}
                        to="/template/public"
                      />
                     {(packageDetails?.package?.title == "Enterprise" || packageDetails?.package?.title == "Free") && <Tab
                        className="templateTab2"
                        style={{
                          margin: "5px 0px 0px",
                          textTransform: "uppercase",
                          fontSize: 10,
                          fontWeight: "bold",
                      
                          backgroundColor:
                            value == 3 ? Colors.globalColor9 : "transparent",
                          color: value == 3 ? Colors.globalColor8 : "black",
                        }}
                        label={t("Archives")} 
                        {...a11yProps(2)}
                        component={Link}
                        to="/template/archive"
                      />}
                    </AntTabs>
                  )}
                  {/* For Mobile */}
                  {window.innerWidth <= 500 && (
                    <AntTabs
                      className="scheduleTabHeader"
                      style={{ color: Colors.buttonTextColor }}
                      value={value}
                      onChange={handleChange}
                      aria-label="simple tabs example"
                    >
                      <Tab
                        className="templateTab3"
                        style={{
                          margin: "5px 0px",
                          textTransform: "uppercase",
                          fontSize: 8,
                          fontWeight: "bold",
                          backgroundColor:
                            value == 0 ? Colors.globalColor9 : "transparent",
                          color: value == 0 ? Colors.globalColor8 : "black",
                        }}
                        label={t("My Templates")} 
                        {...a11yProps(0)}
                        component={Link}
                        to="/template"
                      />
                      <Tab
                        className="templateTab3"
                        style={{
                          margin: "5px 0px",
                          textTransform: "uppercase",
                    
                          fontWeight: "bold",
                          fontSize: 8,
                          backgroundColor:
                            value == 1 ? Colors.globalColor9 : "transparent",
                          color: value == 1 ? Colors.globalColor8 : "black",
                        }}
                        label={t("Response")} 
                        {...a11yProps(1)}
                        component={Link}
                        to="/template/response"
                      />
                      <Tab
                        className="templateTab3"
                        style={{
                          margin: "5px 0px",
                          textTransform: "uppercase",
                          fontSize: 8,
                          fontWeight: "bold",
                         
                          backgroundColor:
                            value == 2 ? Colors.globalColor9 : "transparent",
                          color: value == 2 ? Colors.globalColor8 : "black",
                        }}
                        label="Public Library"
                        {...a11yProps(2)}
                        component={Link}
                        to="/template/public"
                      />
                      {(packageDetails?.package?.title == "Enterprise" || packageDetails?.package?.title == "Free") && <Tab
                        className="templateTab3"
                        style={{
                          margin: "5px 0px",
                          textTransform: "uppercase",
                          fontSize: 8,
                          fontWeight: "bold",
                          backgroundColor:
                            value == 3 ? Colors.globalColor9 : "transparent",
                          color: value == 3 ? Colors.globalColor8 : "black",
                        }}
                        label={t("Archives")} 
                        {...a11yProps(2)}
                        component={Link}
                        to="/template/archive"
                      />}
                    </AntTabs>
                  )}
                </Grid>
                {packageDetails && <Grid item xs={12} md={12} lg={2}>
                  {permissions_obj && packageDetails && (
                    <>
                      {packageDetails?.template_limit !== "Unlimited" && (
                        <>
                          {packageDetails?.template_limit > packageDetails?.template_count ? (
                            <>
                              {userData?.super_admin == true ||
                              permissions_obj["Admin"] == true ||
                              permissions_obj["Template Creation"] == true ? (
                                <Button
                                  style={{
                                    width:
                                      window.innerWidth < 500 ? "100%" : "auto",
                                    paddingRight: "2px",
                                    paddingLeft: "2px",
                                    marginRight:
                                      window.innerWidth > 700 && "20px",
                                  }}
                                  className="ctBtn"
                                  onClick={() => createCustomTemplate()}
                                >
                                  {t("New Template")} 
                                </Button>
                              ) : (
                                <Button
                                  className="ctBtn2"
                                  style={{
                                    backgroundColor: "#dadada",
                                    width:
                                      window.innerWidth < 500 ? "100%" : "auto",
                                    paddingRight: "2px",
                                    paddingLeft: "2px",
                                    marginRight:
                                      window.innerWidth > 700 && "20px",
                                  }}
                                >
                                  {t("New Template")} 
                                </Button>
                              )}
                            </>
                          ) : (
                            <Link to="/update_package">
                              <Button
                                className="ctBtn"
                                style={{ width: "100%" }}
                              >
                                {t("Upgrade Package")}
                              </Button>
                            </Link>
                          )}
                        </>
                      )}

                      {packageDetails?.template_limit === "Unlimited" && (
                        <>
                          {userData?.super_admin == true ||
                          permissions_obj["Admin"] == true ||
                          permissions_obj["Template Creation"] == true ? (
                            <Button
                              style={{
                                width: "100%",
                                paddingRight: "2px",
                                paddingLeft: "2px",
                              }}
                              className="ctBtn"
                              onClick={() => createCustomTemplate()}
                            >
                              {t("New Template")} 
                            </Button>
                          ) : (
                            <Button
                              className="ctBtn2"
                              style={{
                                width: "100%",
                                paddingRight: "2px",
                                paddingLeft: "2px",
                                backgroundColor: "#dadada",
                              }}
                            >
                              {t("New Template")} 
                            </Button>
                          )}
                        </>
                      )}
                    </>
                  )}
                </Grid>}
              </Grid>
            </Grid>

            <div style={{ width: "100%" }}>
              <Switch>
                <Route exact path="/template/" component={Template1} />
                <Route exact path="/template/response" component={Template2} />
                <Route exact path="/template/public" component={Template3} />
                {(packageDetails?.package?.title == "Enterprise" || packageDetails?.package?.title == "Free") && <Route exact path="/template/archive" component={Template4} />}
              </Switch>
            </div>
          </Grid>
        </div>
      </div>
    </>
  );
}

const comp1 = () => {
  return <h1>Comp1</h1>;
};

const comp2 = () => {
  return <h1>Comp2</h1>;
};

const comp3 = () => {
  return <h1>Comp3</h1>;
};
const comp4 = () => {
  return <h1>Comp4</h1>;
};
export default TemplateNav;
